import ThemeModel from '../ThemeModel';
import image from "../../assets/infinity_logo.svg";
import imageLoad from "../../assets/infinity_logo_2.svg";

const Theme = new ThemeModel({
  site_name: 'Trevo Sport',
  site_name_header: 'Trevo Sport',
  logo_site: image,
  logo_site_load: imageLoad,
  logo_login: imageLoad,
  logo_reprint: imageLoad,
});

export default Theme;